/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
const e={redo:"r",undo:"z",center:"Alt",constraint:"Shift",cancel:"Escape",delete:["Backspace","Delete"],complete:"Enter",vertexAdd:"f",pan:" "},t={toggle:"Control"},n={enterInputMode:"Tab",commit:"Enter",discard:"Escape",next:"Tab"};export{e as sketchKeys,t as snappingKeys,n as tooltipKeys};
